import React from 'react';
import { Row, Col } from 'react-bootstrap';
import FormInput from '../../form/FormInput';

const StepSocialMedia = ({ control, errors, isWhatsappSame }) => (
    <div className="animate-fade-in">
        <div className="form-section-title">Social Links</div>
        <Row>
            <Col md={3}><FormInput name="imdbUrl" label="IMDB URL" control={control} errors={errors} /></Col>
            <Col md={3}><FormInput name="youtubeUrl" label="YouTube URL" control={control} errors={errors} /></Col>
            <Col md={3}><FormInput name="whatsappNo" label="WhatsApp No" control={control} errors={errors} readOnly={isWhatsappSame} /></Col>
            <Col md={3}><FormInput name="instagramProfileUrl" label="Instagram URL" control={control} errors={errors} /></Col>
        </Row>
        <Row>
            <Col md={4}><FormInput name="facebookProfileUrl" label="Facebook URL" control={control} errors={errors} /></Col>
            <Col md={4}><FormInput name="twitterProfileUrl" label="Twitter URL" control={control} errors={errors} /></Col>
            <Col md={4}><FormInput name="linkedinProfileUrl" label="LinkedIn URL" control={control} errors={errors} /></Col>
        </Row>
    </div>
);

export default StepSocialMedia;